import React, { useState } from "react";
import { Field, Button } from "../../components/primitives";
// constants/legal.js has no imports, so it is shared as-is.
import { getClubInitials } from "../../../../utils/clubInitials";
import { PRIVACY_POLICY_URL, TERMS_URL } from "../../../../constants/legal";

export function NameStep({ v, set }) {
  return (
    <div className="grid g2">
      <Field label="First name" value={v.firstName} onChange={(e) => set.setFirstName(e.target.value)} autoComplete="given-name" autoFocus data-testid="signUp.firstName" />
      <Field label="Last name" value={v.lastName} onChange={(e) => set.setLastName(e.target.value)} autoComplete="family-name" data-testid="signUp.lastName" />
    </div>
  );
}

export function EmailStep({ v, set }) {
  return (
    <>
      <Field label="UM email" type="email" placeholder="you@miami.edu" value={v.email} onChange={(e) => set.setEmail(e.target.value)} autoComplete="username" autoFocus data-testid="signUp.email" />
      <p className="meta">Only @miami.edu addresses can sign up.</p>
    </>
  );
}

export function PasswordStep({ v, set }) {
  return (
    <>
      <Field label="Password" type="password" value={v.password} onChange={(e) => set.setPassword(e.target.value)} autoComplete="new-password" hint="At least 6 characters." autoFocus data-testid="signUp.password" />
      <Field label="Confirm password" type="password" value={v.confirm} onChange={(e) => set.setConfirm(e.target.value)} autoComplete="new-password" data-testid="signUp.confirmPassword" />
    </>
  );
}

export function DetailsStep({ v, set, onSkip }) {
  return (
    <>
      <div className="grid g2">
        <Field label="Major" placeholder="e.g. Marine Biology" value={v.major} onChange={(e) => set.setMajor(e.target.value)} autoFocus data-testid="signUp.major" />
        <Field
          label="Class year" data-testid="signUp.classYear" placeholder="e.g. 2027" inputMode="numeric" maxLength={4} value={v.gradYear}
          onChange={(e) => set.setGradYear(e.target.value.replace(/\D/g, "").slice(0, 4))}
        />
      </div>
      <button type="button" className="link" style={{ alignSelf: "flex-start" }} onClick={onSkip} data-testid="signUp.skip">Skip for now</button>
      <label className="auth-terms">
        <input type="checkbox" data-testid="signUp.terms" checked={v.accepted} onChange={(e) => set.setAccepted(e.target.checked)} />
        <span>
          I have read and agree to the{" "}
          <a className="link" href={TERMS_URL} data-testid="signUp.termsLink" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> and{" "}
          <a className="link" href={PRIVACY_POLICY_URL} data-testid="signUp.privacyLink" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </span>
      </label>
    </>
  );
}

export function PhotoStep({ photo, picking, locked, onPick, onFile, onClear, name }) {
  const [over, setOver] = useState(false);
  const initials = getClubInitials(name) || "?";
  return (
    <div
      className={`auth-drop${over ? " over" : ""}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); if (locked) return; const f = e.dataTransfer.files?.[0]; if (f) onFile(f); }}
    >
      <div className="row" style={{ gap: 16 }}>
        {photo
          ? <img className="auth-photo" src={photo} alt="Your profile preview" />
          : <span className="avatar" style={{ "--a": "84px" }} aria-hidden="true">{initials}</span>}
        <div className="col" style={{ gap: 8 }}>
          <Button variant="sec" size="sm" icon="upload" onClick={onPick} disabled={picking || locked} data-testid="signUp.photo.pick">{picking ? "Processing…" : photo ? "Choose a different photo" : "Upload photo"}</Button>
          {photo && <button type="button" className="link" style={{ alignSelf: "flex-start" }} onClick={onClear} disabled={locked} data-testid="signUp.photo.remove">Remove photo</button>}
          <span className="meta">Drag an image here, or choose one.</span>
        </div>
      </div>
    </div>
  );
}
